<ai-ui-bank-base [operation]="'edit'"></ai-ui-bank-base>